import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { secondaryBlockVars, tertiaryBlockVars } from './Block.palette';

export const snapBlockPrimaryVars: MotifComponentProps<MotifComponent.BLOCK> = {
  ...tertiaryBlockVars,
  '--block-title-de-emphasized-color': m('--neutral-v500'),
} as const;

export const snapBlockSecondaryVars: MotifComponentProps<MotifComponent.BLOCK> = {
  ...secondaryBlockVars,
  '--block-title-de-emphasized-color': m('--neutral-v250'),
} as const;
